import api from '../api/client';

const getTrail = async (appId, params = {}) => {
    const res = await api.get('/api/audit-trail', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

const getActions = async (appId) => {
    const res = await api.get('/api/audit-trail/actions', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getStats = async (appId, params = {}) => {
    const res = await api.get('/api/audit-trail/stats', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

const auditTrailService = { getTrail, getActions, getStats };

export default auditTrailService;
